<template>
  <v-container>
    <v-breadcrumbs class="px-0 text-uppercase" :items="items"></v-breadcrumbs>
    <v-img eager :src="our_service_detail ? our_service_detail[0].image_cover : ''" style="border-radius: 4px;"></v-img>
    <v-row class="my-10" align="center" justify="center">
      <v-col class="text-center">
        <span class="text-tcdc-green header bold">{{our_service_detail ? our_service_detail[0][`topic_${lang}`] : ''}}</span>
      </v-col>
    </v-row>
    <v-layout column>
      <template v-for="(detail,index) in our_service_detail">
        <v-flex mb-12 :key="index">
          <v-layout justify-space-between :column="$vuetify.breakpoint.smAndDown">
            <v-flex class="d-flex align-center justify-center mb-5">
                <v-img
                    eager
                    :src="detail.image"
                    contain
                    :max-width="$vuetify.breakpoint.smAndDown ? 300:200"
                    :max-height="$vuetify.breakpoint.smAndDown ? 200:200"
                ></v-img>
            </v-flex>
            <v-flex md7 class="d-flex align-center">
              <div>
                <div class="text-tcdc-green bold sub-header2">{{detail[`title_${lang}`]}}</div>
                <div class="text-tcdc-grey1" v-html="detail[`detail_${lang}`]">

                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import GreenButton from "../../../components/buttons/GreenButton";
import { mapState } from "vuex";
import {BreadcrumbUtil} from "../../../util/BreadcrumbUtil";

export default {
  components: {
    // GreenButton
  },
  created() {
    let id = this.$route.query.id;
    this.$store.dispatch("ServiceMenu/getOurServiceDetail", id).then(res =>{
      this.items[2].text = res[0].topic_en;
    });
    this.items = BreadcrumbUtil.setServiceItem(
            this.items,
            this.branchId,
            this.branchName,
            this.allBranches,
            this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      our_service_detail: state => state.ServiceMenu.our_service_detail,
      lang: state => state.Branch.lang,
      branchId: state => state.Branch.branch_id,
      allBranches: state => state.Branch.branches,
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
              this.items,
              this.branchId,
              this.branchName,
              this.allBranches,
              this.lang
      )
    }
  },
  methods: {
    openLink(link) {
      window.open(link);
    },
    routeTo(target) {
      this.$router.push(`/${this.lang}`+target);
    }
  },
  data: () => ({
    items: [
      {
        text: 'ALL BRANCHES',
        disabled: false,
        to: "/home"
      },
      {
        text: "OUR SERVICE",
        disabled: false,
        to: '/our-service'
      },
      {
        text: "OUR SERVICE",
        disabled: true
      }
    ]
  })
};
</script>

<style scoped lang="scss">
  .txt-link {
    cursor: pointer;
  }
  .txt-link:hover {
    color: #2e8037;
  }
</style>
